module.exports = __webpack_public_path__ + "img/Icon-navigation-search.3d956ad7.svg";